import { render, staticRenderFns } from "./NotificationNewDocumentDialog.vue?vue&type=template&id=d5a60030&scoped=true&"
import script from "./NotificationNewDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./NotificationNewDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationNewDocumentDialog.vue?vue&type=style&index=0&id=d5a60030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a60030",
  null
  
)

export default component.exports